import React, { useContext, useEffect, useState } from 'react'
import DetailsBox from '../../../../../components/Cards/DetailsBox'

//@MUI
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import FormPanel from './FormPanel'
import API from '../../../../../services/API'
import { EventMetaContext } from '../../SingleEvent'
import moment from 'moment'
import { Typography } from '@mui/material'

const MedPlan = ({ embedded = false }) => {
  const { eventMeta } = useContext(EventMetaContext)
  const [accordionOpen, setAccordionOpen] = useState(
    moment().isAfter(eventMeta.endDate) || eventMeta.EMPApproved ? false : true,
  )

  if (embedded) {
    return <FormPanel />
  }

  return (
    <Box border="solid 1px #39485e" borderRadius={1}>
      <Accordion disableGutters expanded={accordionOpen}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: 'flex',
          }}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <Typography variant="title3">Clinical Considerations</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormPanel />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default React.memo(MedPlan)
